<template>
  <vs-popup :title="$t('Products')" :active.sync="showModal">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          v-if="showModal"
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[{ title: $t('ItemCode') }, { title: $t('Price') }]"
        >
          <template slot-scope="{ row }">
            <td style="width: 50%">
              {{ row.itemCode }}
            </td>
            <td style="width: 50%">
              {{ row.price.toLocaleString() }}
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </vs-popup>
</template>
<style lang="scss" scoped></style>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "saleManagement_Contract_Management_SpecificProductPopup",
  components: {
    DataGrid,
  },
  props: {
    show: { default: false },
    baseSalePriceId: {
      type: Number,
    },
    keywords: {},
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: `/Sales/api/BaseSalePriceQuery/${this.baseSalePriceId}/items`,
      },
      gridSearchData: {},
    };
  },
  mounted() {},
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {},
};
</script>
